<template>
  <div>
    <!-- Trigger Button -->
    <b-button
      variant="danger"
      @click="$bvModal.show('clear-inflight-modal')"
    >
      Clear Inflight Trips
    </b-button>

    <!-- Modal -->
    <b-modal
      id="clear-inflight-modal"
      title="Clear Inflight Trips"
      :ok-disabled="submitting || !form.date || !form.time"
      :busy="submitting"
      @ok.prevent="handleSubmit"
      @hidden="resetForm"
    >
      <!-- Modal Content -->
      <b-form @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Date"
          label-for="trip-date"
        >
          <b-form-datepicker
            id="trip-date"
            v-model="form.date"
            :value-as-date="true"
            required
            :max="new Date()"
          />
          <b-form-timepicker
            v-model="form.time"
            class="mt-2"
            :value-as-date="true"
            required
          />
        </b-form-group>
      </b-form>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="submitting || !form.date || !form.time"
          class="d-flex align-items-center"
          @click="handleSubmit"
        >
          <b-spinner
            v-if="submitting"
            small
            type="border"
            class="mr-2"
          />
          {{ submitting ? 'Submitting...' : 'Submit' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  BForm,
  BFormGroup,
  BFormDatepicker,
  BFormTimepicker,
  VBModal,
  BSpinner,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
// import { errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

export default {
  name: 'ClearInflightTrips',
  components: {
    BButton,
    BModal,
    BSpinner,
    BForm,
    BFormGroup,
    BFormDatepicker,
    BFormTimepicker,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    entityType: {
      type: String,
      required: true,
    },
  },
  setup(props, { root }) {
    const form = ref({
      date: null,
      time: null,
    })

    const submitting = ref(false)

    const handleSubmit = async () => {
      if (!form.value.date || !form.value.time) return

      submitting.value = true

      const combinedDate = new Date(form.value.date)

      try {
        const [hours, minutes] = form.value.time.split(':').map(Number)
        combinedDate.setHours(hours, minutes)

        // const now = new Date()

        // const twoHoursAgo = new Date(now.getTime() - 2 * 60 * 60 * 1000)

        // if (combinedDate > twoHoursAgo) {
        //   errorNotification('Datetime must be at least 2 hours before now')
        //   return
        // }
        await axiosIns.post('/trips/clear-inflight-trips', {
          type: props.entityType,
          date: combinedDate.toISOString(),
        })

        root.$bvToast.toast('Inflight trips cleared successfully.', {
          title: 'Success',
          variant: 'success',
          solid: true,
        })

        root.$bvModal.hide('clear-inflight-modal')
      } catch (err) {
        root.$bvToast.toast('Failed to clear inflight trips.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        submitting.value = false
      }
    }

    const resetForm = () => {
      form.value.date = null
      form.value.time = null
    }
    return {
      form,
      submitting,
      handleSubmit,
      resetForm,
    }
  },
}
</script>
